module.exports = __webpack_public_path__ + "officialStatic/img/mj.84f9be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/mj.png
// module id = SKlz
// module chunks = 0